import { render, staticRenderFns } from "./tact.vue?vue&type=template&id=4ff1e1d0&scoped=true&"
import script from "./tact.vue?vue&type=script&lang=js&"
export * from "./tact.vue?vue&type=script&lang=js&"
import style0 from "./tact.vue?vue&type=style&index=0&id=4ff1e1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff1e1d0",
  null
  
)

export default component.exports